import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { Authenticated } from '../components/auth';

const PrivateRoute = ( {
  component, layout, allowedRoles, ...rest
} ) => (
  <Route {...rest}>
    <Authenticated component={component} layout={layout} allowedRoles={allowedRoles} />
  </Route>
);

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType( [PropTypes.object, PropTypes.func] ).isRequired,
  layout: PropTypes.oneOfType( [PropTypes.object, PropTypes.func] ).isRequired,
  allowedRoles: PropTypes.arrayOf( PropTypes.string ).isRequired,
};

export default PrivateRoute;
